export default {
  '测试记录列表':'測試記錄列表',
  '视频不存在':'視頻不存在',
  '测试记录':'測試記錄',
  '此记录暂无报告':'此記錄暫無報告',
}